/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const group = useRef()
  const { nodes, materials } = useGLTF('/charisma/road/road-2.gltf')
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh 
      geometry={nodes.Line2000014415.geometry} 
      material={materials.Grass} 
      material-roughness={1}
      position={[-114.19, -0.03, -5.75]} 
      receiveShadow
      />
      <mesh 
      geometry={nodes.Line2000014417.geometry} 
      material={materials.Roads} 
      material-roughness={1}
      receiveShadow
      />
      <mesh 
      geometry={nodes.Line2000014418.geometry} 
      material={materials['dark-concrete']} 
      material-roughness={1}
      receiveShadow
      />
      <mesh 
      geometry={nodes.Line2000014419.geometry} 
      material={nodes.Line2000014419.material} 
      material-roughness={1}
      receiveShadow
      />
      <mesh 
      geometry={nodes.Plane4623.geometry} 
      material={nodes.Plane4623.material} 
      material-roughness={1}
      receiveShadow
      />
      <mesh 
      geometry={nodes.ph2_walks001.geometry} 
      material={materials.Stripxz} 
      material-roughness={1}
      receiveShadow
      />
    </group>
  )
}

useGLTF.preload('charisma/road/road-2.gltf')
